import { Box, IconButton } from '@mui/material';
import React from 'react';
import {
  TypographyH1Bold,
  TypographyH4Bold
} from '../../../features/estimatingRequirements/peng2018/style';

export const TextWithInfoIcon = ({
  icon,
  title,
  fontSize,
  lineHeight,
  variant,
  handleIconClick,
  testId,
  fontColor,
  marginTop,
  margin,
  marginBottom,
  boxHeight,
  textAlign,
  customTopInfoIcon
}: {
  icon: string;
  title: string;
  fontSize: string;
  lineHeight: string;
  variant: 'h1' | 'h4';
  handleIconClick: () => void;
  testId?: string;
  fontColor?: string;
  marginTop?: string;
  margin?: string;
  marginBottom?: string;
  boxHeight?: string;
  textAlign?: string;
  customTopInfoIcon?: string;
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '100%',
      height: boxHeight ? boxHeight : '70px'
    }}
  >
    {/* Centered Typography */}
    {variant === 'h1' ? (
      <TypographyH1Bold
        variant={variant}
        sx={{
          textAlign: textAlign || 'center',
          flex: 1 // Takes equal space to keep Typography in the center,
        }}
      >
        {title}
      </TypographyH1Bold>
    ) : (
      <TypographyH4Bold
        variant={variant}
        sx={{
          textAlign: textAlign || 'center',
          flex: 1, // Takes equal space to keep Typography in the center,
          textTransform: 'uppercase',
          color: fontColor ? fontColor : '#002A3A',
          marginTop: marginTop ? marginTop : 0,
          margin: margin ? margin : 0,
          marginBottom: marginBottom ? marginBottom : 0
        }}
      >
        {title}
      </TypographyH4Bold>
    )}

    {/* Floated IconButton */}
    <IconButton
      onClick={handleIconClick}
      size="small"
      aria-label="info"
      data-testid={testId}
      sx={{
        position: 'absolute',
        right: 0, // Floats to the right
        top: customTopInfoIcon ? customTopInfoIcon : '50%',
        transform: 'translateY(-50%)' // Vertically centers the button
      }}
    >
      <img src={icon} alt="Info" width="20" height="20" />
    </IconButton>
  </Box>
);
